// extracted by mini-css-extract-plugin
export default {"popup":"SearchClientResultPopup_popup__jkj8b","content":"SearchClientResultPopup_content__ZhUUm"};